import { render, staticRenderFns } from "./UpdatePasienDetails.vue?vue&type=template&id=8bff84a0"
import script from "./UpdatePasienDetails.vue?vue&type=script&lang=js"
export * from "./UpdatePasienDetails.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\Project\\Work\\laporan-rl\\sembiring_rekammedis\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('8bff84a0')) {
      api.createRecord('8bff84a0', component.options)
    } else {
      api.reload('8bff84a0', component.options)
    }
    module.hot.accept("./UpdatePasienDetails.vue?vue&type=template&id=8bff84a0", function () {
      api.rerender('8bff84a0', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/js/components/app/home/master_pasien/UpdatePasienDetails.vue"
export default component.exports